module.exports = __webpack_public_path__ + "img/tips9.b83c074f.png";